<template>
  <div style="padding:20px 50px">
    <lay-col md="24">
      <div >
        <lay-card>
          <template #title>
            当前选择时间：{{now}} 数据总条数：{{monitorData.length}}条.
          </template>
          <template v-slot:body>
            <lay-row space="10">
              <lay-col md="24" v-if="type == 0">
                <div  style="text-align: center;line-height: 20px;color: #363636">
                  说明：<span>ia：A相电流</span>&nbsp;
                  <span>ib：B相电流</span>&nbsp;
                  <span>ic：C相电流</span>&nbsp;
                  <span>i：平均相电流</span>&nbsp;
                  <span>u：平均相电压</span>&nbsp;
                  <span>ux：平均线电压</span>&nbsp;
                  <span>p：有功功率</span>&nbsp;
                  <span>q：无功功率</span>&nbsp;
                  <span>pf：功率因数</span>&nbsp;
                  <span>w：用电量（当天底数：{{firstData?.w}}kW·h）</span>
                </div>
              </lay-col>
            </lay-row>
            <v-chart ref="vchart" class="chart" :option="option" @click="handleChartClick"></v-chart>
          </template>
        </lay-card>
      </div>
    </lay-col>
  </div>
</template>

<script setup>
import {ref, watch, defineProps} from "vue";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart} from "echarts/charts";
import {TitleComponent, TooltipComponent, LegendComponent, GridComponent, DataZoomComponent,ToolboxComponent, MarkPointComponent} from "echarts/components";
import VChart from "vue-echarts";
import axios from "axios";
import {layer} from "@layui/layui-vue";
import _ from "lodash";

use([CanvasRenderer, LineChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent, DataZoomComponent, ToolboxComponent, MarkPointComponent]);

const props = defineProps(['id', 'location','type', 'now','name'])
const vchart = ref()
// const dataSource = ref([]);
const monitorData = ref([])
let pageNum = 0, pageSize = 150;
let firstData = ref();
const loading = ref(false);
const historyDate = ref()
const dumps = ref([])
const currentSelected = ref(-1);


watch(historyDate, () => {
  currentSelected.value = -1;
  for (let i = 0 ; i < dumps.value.length ; i++){
    if (dumps.value[i].from.indexOf(historyDate.value) != -1){
      currentSelected.value = i;
      break;
    }
  }
  console.log("watch " + currentSelected.value)
})




function realTimeDataCacheForOneWeek(){
  axios.get(`/realtime/data/cached_for_one_week?location=${props.location}&pageNum=${pageNum++}&pageSize=${pageSize}&record_id=${props.id}`)
      .then(function (response) {
        if (response.data.code == 0){
          if (!firstData.value){
            firstData.value = response.data.data['list'][0];
          }
          monitorData.value.push(...(response.data.data['list']));
          if (response.data.data['isLastPage'] == false){
            setTimeout(() => {
              realTimeDataCacheForOneWeek();
            }, 200)
          }
          else {
            loading.value = true;
            renewChart()
            layer.closeAll()
          }
        }
      })
      .catch(function () {
        console.log("网络请求失败，请稍后重试")
        layer.closeAll()
      })
      .finally(function () {

      });
}

function handleChartClick(){
  console.log('click vchart')
}

function renewChart(){
  let innerOption = vchart.value.getOption();
  let configs = series_configs();
  for (let i = 0 ; i < configs.length ; i++){
    innerOption.series[i].data = configs[i].data;
  }
  innerOption.xAxis[0].data = (() => {
    let _data = []
    for (let d of monitorData.value){
      _data.push(d['now'])
    }
    return _data;
  })()
  vchart.value.setOption(innerOption, true)
  console.log("---P---")
  console.log(_.maxBy(monitorData.value, v => parseFloat(v.p)))
  console.log(_.minBy(monitorData.value, v => parseFloat(v.p)))
  console.log("---I---")
  console.log(_.maxBy(monitorData.value, v => parseFloat(v.i)))
  console.log(_.minBy(monitorData.value, v => parseFloat(v.i)))
  console.log(vchart.value)
}

realTimeDataCacheForOneWeek()
layer.load(0, { time: 9999999999})


const realtime_series_config = (name, color, data, fieldName = undefined) => {
  return {
    name: name,
    type: 'line',
    symbol: 'none',
    sampling: 'lttb',
    itemStyle: {
      color: color
    },
    markPoint: {
      data: [
        {type: 'max', name: '最大值'},
        {type: 'min', name: '最小值',symbolRotate: '180',label: {offset: [0, 10]}}
      ]
    },
    data: (() => {
      let _data = []
      for (let d of data){
        if (name == 'w'){
          _data.push(parseInt((d['w'] - firstData.value.w) * 100) / 100.0)
        }
        else {
          _data.push(d[fieldName ?? name])
        }
      }
      return _data;
    })()
  }
}

const option = (() => {
  if (props.type == 0){
    return {
      title: {
        text: '{' + props.now + '} ' + props.name,
        left: "left"
      },
      tooltip: {
        trigger: 'axis',
        position: function (pt) {
          return [pt[0], '10%'];
        }
      },
      legend: {
        data: ['ia','ib', 'ic', "i", 'u', 'ux', "p", "q", "pf","开关量", 'w'],
        selected: {
          "ia": false,
          "ib": false,
          "ic": false,
          "i": false,
          "u": false,
          "ux": false,
          "p": true,
          "q": false,
          "pf":false,
          "开关量":false,
          "w":false
        }
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: []
      },
      yAxis: {
        type: 'value',
        boundaryGap: [0, '100%']
      },
      toolbox: {
        feature: {
          // dataZoom: {
          //   yAxisIndex: 'none'
          // },
          // restore: {},
          saveAsImage: {
            name
          }
        }
      },
      dataZoom: [{
        type: 'inside',
        start: 0,
        end: 100
      }, {
        start: 0,
        end: 10
      }],
      series: series_configs()
    };
  }
  else if (props.type == 11){
    return {
      title: {
        text: "",
        left: "left"
      },
      tooltip: {
        trigger: 'axis',
        position: function (pt) {
          return [pt[0], '10%'];
        }
      },
      legend: {
        data: ['湿度',"温度"],
        selected: {
          "湿度": true,
          "温度": true,
        },
        formatter:(name) => {
          if (name == '湿度') return name + " %RH";
          if (name == '温度') return name + " ℃";
          return name;
        }
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: []
      },
      yAxis: {
        type: 'value',
        boundaryGap: [0, '100%']
      },
      toolbox: {
        feature: {
          // dataZoom: {
          //   yAxisIndex: 'none'
          // },
          // restore: {},
          saveAsImage: {
            name
          }
        }
      },
      dataZoom: [{
        type: 'inside',
        start: 0,
        end: 100
      }, {
        start: 0,
        end: 10
      }],
      series: series_configs()
    };
  }
})();

function series_configs(){
  if (props.type == 0){
    return [
      realtime_series_config('ia', '#27408b', monitorData.value),
      realtime_series_config('ib', '#ec4cff', monitorData.value),
      realtime_series_config('ic', '#b0493b', monitorData.value),
      realtime_series_config('i', '#EE9A00', monitorData.value),
      realtime_series_config('u', '#00b050', monitorData.value),
      realtime_series_config('ux', '#ff0000', monitorData.value),
      realtime_series_config('p', '#EE9A00', monitorData.value),
      realtime_series_config('q', '#00b050', monitorData.value),
      realtime_series_config('pf', '#ff0000', monitorData.value),
      realtime_series_config('开关量', '#ff0000', monitorData.value, "di"),
      realtime_series_config('w', '#b0493b', monitorData.value),

    ]
  }
  else if (props.type == 11){
    return [
      realtime_series_config('湿度', '#00b050', monitorData.value, 'u'),
      realtime_series_config('温度', '#EE9A00', monitorData.value, 'i'),
    ]
  }
}




</script>

<style >
.chart{
  height: 650px;
  padding-top: 20px;
}
.download{
  font-size: 23px;cursor: pointer;
}
.refresh{
  font-size: 18px;cursor: pointer;
}
.layui-date-picker-static .layui-laydate-main-date{
  width: auto;
}
.date-cell {
  width: 44px;
  height: 40px;
  display: flex;
  flex-direction: column;
}
</style>